import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from "@angular/http";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LightboxModule } from 'angular2-lightbox';

import { ImageService } from "./service/app.image.service"
import { AppComponent } from './app.component';
import { HeaderComponent } from "./shared/app.header.component";
import { FotterComponent } from "./shared/app.footer.component";
import { CameraComponent } from "./camera/app.camera.component";
import { CameraArchiveComponent } from "./camera/app.camera.archive.component";

var routes = [
  { path: "", component: CameraComponent, useAsDefault: true },
  { path: "history/:id", component: CameraArchiveComponent },
  { path: "**", component: CameraComponent},
]

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FotterComponent,
    CameraComponent,
    CameraArchiveComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    LightboxModule,
    RouterModule.forRoot(routes)
  ],
  providers: [ImageService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/pgutev/work/WEBCAM/src/app/app.module.ts